import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $:any;

@Component({
  selector: 'app-account-tickets-page',
  templateUrl: './account-tickets-page.component.html',
  styleUrls: ['./account-tickets-page.component.css']
})
export class AccountTicketsPageComponent implements OnInit {

  pageName = "My Tickets";
  
  constructor(private router: Router) { }

  ngOnInit() {

  	$('#initialise-page').trigger('click');
  }

  createTicket(){
    this.router.navigate(['/account/submit-ticket']);
  }

}
